export default __webpack_public_path__ + "static/media/undraw_team_spirit_hrr4.1a3ef1da.svg";